import { WatcherRegex, WatcherRegexResult } from "@/utils/watcher";
import { computed, ref } from "vue";

export type RegexResult = WatcherRegexResult & {
	sitemap: string;
	url: string;
};

// used to assign a unique id to each regex
let regexesIdSequence = 1;

export const regexWatcherService = (() => {
	const regexes = ref<(WatcherRegex & { id: number; enabled: boolean })[]>(
		[]
	);
	const getRegexById = (id: number) =>
		regexes.value.find(regex => regex.id === id);

	const regexResults = ref<RegexResult[]>([]);

	const addNewRegex = (regex: string, name: string) => {
		if (!regex || !name) {
			return;
		}

		if (!name) {
			name = `Regex ${regexesIdSequence + 1}`;
		}

		regexes.value.push({
			id: regexesIdSequence++,
			name,
			regex,
			enabled: false,
		});
		saveRegexes(regexes.value);
	};

	const removeRegex = (id: number) => {
		regexes.value = regexes.value.filter(regex => regex.id !== id);
		saveRegexes(regexes.value);
	};

	const enabledRegexes = computed(() =>
		regexes.value.filter(regex => regex.enabled)
	);
	const setRegexEnabled = (id: number, enabled: boolean) => {
		const regex = getRegexById(id);
		if (regex) {
			regex.enabled = enabled;
		}
	};

	// restore regexes from localSTorage
	for (const regex of restoreRegexes()) {
		addNewRegex(regex.regex, regex.name);
	}

	return {
		regexes,
		regexResults,
		addNewRegex,
		removeRegex,

		enabledRegexes,
		setRegexEnabled,
	};
})();

type SavedRegex = { name: string; regex: string };

function saveRegexes(regexes: SavedRegex[]) {
	localStorage.setItem(
		"regexes",
		JSON.stringify(
			regexes.map(regex => ({ name: regex.name, regex: regex.regex }))
		)
	);
}

function restoreRegexes(): SavedRegex[] {
	const regexes = localStorage.getItem("regexes");
	return regexes ? JSON.parse(regexes) : [];
}
